/* unplugin-vue-components disabled */import script from "./OrderCard.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderCard.vue?vue&type=script&setup=true&lang=js"

import "./OrderCard.vue?vue&type=style&index=0&id=8f6c13f4&lang=scss"

const __exports__ = script;

export default __exports__